/**
 * レーダライン
 */
import Repository from "./MapRepository";

const resource = "";
export default {
  /**
   * XRAIN定量範囲のライン取得
   */
  getXrainLine() {
    return Repository.get(`${resource}/radar/teiryou.json`);
  },
  /**
   * Cバンド定性範囲のライン取得
   */
  getCbandLine() {
    return Repository.get(`${resource}/radar/Cteisei.json`);
  },
};
